export default __webpack_public_path__ + "static/media/ratemy3.7589330d.png";